import { BROADCAST_UNMUTE_AUDIO } from '../Types';
import { commonWebAnalytics } from '@studio/metrics';

function unmuteAudio(isRemoteToggle = false) {
  return async (dispatch, getState) => {
    const {
      meeting: { meetingSession }
    } = getState();

    const canUnmute =
      await meetingSession?.audioVideo?.realtimeCanUnmuteLocalAudio();

    if (!canUnmute) {
      console.log('[unmuteAudio] Cannot unmute - permission denied');
      return;
    }

    // SLI payload
    const sliPayload = {
      microphoneState: 'ON',
      isRemoteToggle
    };

    // Start SLI measurement
    commonWebAnalytics.startStudioMicrophoneToggled(sliPayload);

    try {
      await meetingSession.audioVideo.realtimeUnmuteLocalAudio();

      const action = {
        type: BROADCAST_UNMUTE_AUDIO,
        payload: meetingSession.audioVideo.realtimeIsLocalAudioMuted()
      };

      dispatch(action);

      // End SLI measurement on success
      commonWebAnalytics.endStudioMicrophoneToggled(sliPayload);
    } catch (error) {
      console.error('[unmuteAudio] Failed to unmute microphone:', error);

      // End SLI measurement on error
      commonWebAnalytics.endStudioMicrophoneToggled({
        ...sliPayload,
        error: error?.message
      });

      throw error;
    }
  };
}

export default unmuteAudio;
